import { useSelector } from "react-redux";
import { Skeleton } from "antd";
import DashboardPreviewInfo from "../DashboardPreviewInfo";
import DashboardBadge from "../DashboardBadge";
import { getRelativeTime } from "../../../utility/formatter-helper";

function SignalPreview() {
  const {
    dashboard: {
      signalInfoStatus,
      signalInfoError,
      signalInfo: {
        collapsed_preview: { badge_text = "", summary_text = "" } = {},
      },
    },
  } = useSelector((state) => state);

  const splittedText = summary_text?.split("- ");
  const date = splittedText?.[splittedText?.length - 1];
  const previewText = splittedText?.slice(0, -1);

  return (
    <>
      {signalInfoStatus === "loading" && (
        <>
          <Skeleton.Input active size="small" />
          <Skeleton.Input active size="small" />
        </>
      )}

      {signalInfoStatus === "success" && (
        <>
          <DashboardBadge type="primary">{badge_text}</DashboardBadge>
          <DashboardPreviewInfo>
            {previewText}- {getRelativeTime(date)}
          </DashboardPreviewInfo>
        </>
      )}
    </>
  );
}

export default SignalPreview;
